import Vue from "vue";
import Router from "vue-router";
import Store from "../store/index";
import AppIndex from "../views/Index.vue";

//Dynamic routes load - Lazy loading
import {
  Commitment,
  Company,
  CompanyPanel,
  Dashboard,
  Departments,
  Home,
  RoomDetails,
  Rooms,
  Schedules,
  SignUps,
  Totem
} from "./CompanyRoutes";

const User = resolve => {
  // @ts-ignore
  require.ensure(
    ["../views/user/Index.vue"],
    () => {
      resolve(require("../views/user/Index.vue"));
    },
    "User"
  );
};

Vue.use(Router);

function VerificarAcessoPermissao(permissao) {
  let permissoes = Store.state.user_data.meta.permissoes;
  let filter = permissoes.filter(
    item => parseInt(item.id_permissao) === permissao
  );
  if (filter.length == 1) return true;
  else return false;
}

const router = new Router({
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  routes: [
    {
      path: "/",
      name: "index",
      component: AppIndex,
      meta:{
        name:"login",
        ignoreCheck:true
      }
    },
    {
      path: "/company",
      name: "Company",
      redirect: "/company/home",
      component: Company,
      meta:{
        ignoreCheck:true
      },
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
          meta: {
            icon: "fas fa-chart-line",
            disabled: false,
            auth: true,
            showCompanyMenu: false,
            pageTitle: "Dashboard"
          }
        },
        {
          path: "commitment",
          name: "Convites",
          component: Commitment,
          meta: {
            modalTitle: "Criar Convite",
            modalComponent: "FormSchedules",
            action: {
              text: "Novo",
              event: "createCompany",
              icon: "plus"
            },
            icon: "far fa-calendar-alt",
            disabled: false,
            auth: true,
            showCompanyMenu: true,
            pageTitle: "Meus convites"
          }
        },
        {
          path: "home",
          name: "Instituições",
          component: CompanyPanel,
          meta: {
            modalTitle: "Adicionar instituição",
            modalComponent: "FormCompany",
            action: {
              text: "Adicionar Instituição",
              event: "createCompany",
              icon: "plus"
            },
            icon: "far fa-building",
            disabled: false,
            auth: true,
            showCompanyMenu: false,
            pageTitle: "Instituições cadastradas"
          }
        },
        {
          path: "rooms",
          name: "Salas de reunião",
          component: Rooms,
          meta: {
            modalTitle: "Cadastrar Sala de Reunião",
            ignoreCheck:true,
            modalComponent: "FormCreateRoom",
            action: {
              text: "Cadastrar Sala de Reunião",
              event: "newRoom",
              icon: "plus"
            },
            icon: "fas fa-users",
            disabled: false,
            auth: true,
            showCompanyMenu: false,
            pageTitle: "Salas de reunião"
          }
        },
        {
          path: "rooms/:id",
          name: "Agendamento de sala",
          component: RoomDetails,
          meta: {
            modalTitle: "Sala de Reunião",
            ignoreCheck:true,
            modalComponent: "FormRooms",
            action: {
              text: "Reservar Sala de Reunião",
              event: "createCompany",
              icon: "plus"
            },
            icon: "far fa-building",
            disabled: false,
            isShown: false,
            auth: true,
            showCompanyMenu: false,
            pageTitle: "Agendamento de sala de reunião"
          }
        },
        {
          path: "rooms/:id/:bookingId",
          name: "Sala reservada",
          component: RoomDetails,
          meta: {
            modalTitle: "Sala de Reunião",
            ignoreCheck:true,
            modalComponent: "FormRooms",
            action: {
              text: "Reservar Sala de Reunião",
              event: "createCompany",
              icon: "plus"
            },
            icon: "far fa-building",
            disabled: false,
            isShown: false,
            auth: true,
            showCompanyMenu: false,
            pageTitle: "Sala de reunião reservada",
        }
      },
      // {
      //   path: "visitors",
      //   name: "Visitas",
      //   component: Visitors,
      //   meta: {
      //     modalTitle: "Meus agendamentos",
      //     ignoreCheck:true,
      //     modalComponent: "FormRooms",
      //     action: {
      //       text: "Meus agendamentos",
      //       event: "createCompany",
      //       icon: "eye"
      //     },
      //     icon: "fas fa-address-book",
      //     disabled: false,
      //     auth: true,
      //     showCompanyMenu: false,
      //     pageTitle: "Agendamento de visitas"
      //   }
      // },
      ]
    },
    {
      path: "/company/context",
      component: Company,
      name: "CompanyContext",
      meta:{
        ignoreCheck:true
      },
      beforeEnter:(to,from,next)=>{
          if(!Store.state.user_data.master){
              next()
          }else{
            next()
          }
      },
      children: [
        // {
        //   path: "inicio",
        //   name: "Inicio",
        //   component: Inicio,
        //   meta: {
        //     auth: true,
        //     showCompanyMenu: true,
        //     ignoreCheck:true
        //   }
        // },
        {
          path: "home",
          name: "Home",
          component: Home,
          meta: {
            auth: true,
            showCompanyMenu: true,
            ignoreCheck:true,
            pageTitle: "Notificações",
          }
        },
        {
          path: "schedules",
          name: "Agendamentos",
          component: Schedules,
          meta: {
            permissionId: 6,
            modalTitle: "Criar Agendamento",
            modalComponent: "FormSchedules",
            action: {
              text: "Novo",
              event: "createAppointment",
              icon: "plus"
            },
            icon: "far fa-calendar",
            disabled: false,
            auth: true,
            id_permissao: 6,
            showCompanyMenu: true,
            pageTitle: "Agendamentos"
          }
        },
        {
          path: "rooms",
          name: "Salas",
          component: Rooms,
          meta: {
            modalTitle: "Criar Salas",
            modalComponent: "AppModalNewRoom",
            action: {
              text: "Novo",
              event: "createRoom",
              icon: "plus"
            },
            icon: "fas fa-door-open",
            disabled: true,
            auth: true,
            showCompanyMenu: true,
            pageTitle: "Salas"
          }
        },
        {
          path: "signUps",
          name: "Usuarios",
          component: SignUps,
          meta: {
            permissionId: 3,
            modalTitle: "Cadastrar novo usuario",
            modalComponent: "FormUsers",
            action: {
              text: "Novo Cadastro",
              event: "createUser",
              icon: "plus"
            },
            icon: "far fa-user",
            disabled: false,
            auth: true,
            pageTitle: "Usuários",
            showCompanyMenu: true,
            id_permissao: 3
          }
        },
        // {
        //   path: "signUps",
        //   name: "Usuarios",
        //   component: SignUps,
        //   meta: {
        //     permissionId: 3,
        //     modalTitle: "",
        //     modalComponent: "AppModalConfirmation",
        //     action: {
        //       text: "",
        //       event: "",
        //       icon: "plus"
        //     },
        //     icon: "far fa-user",
        //     disabled: false,
        //     auth: true,
        //     pageTitle: "Áreas",
        //     id_permissao: 3
        //   }
        // },
        {
          path: "departments",
          name: "Áreas",
          component: Departments,
          meta: {
            permissionId: 4,
            modalTitle: "Cadastrar nova área",
            modalComponent: "FormDepartments",
            action: {
              text: "Cadastrar área",
              event: "createDeprt",
              icon: "plus"
            },
            icon: "fas fa-cubes",
            disabled: false,
            auth: true,
            id_permissao: 5,
            showCompanyMenu: true,
            pageTitle: "Áreas"
          }
        },
        {
          path: "totem",
          name: "Totem",
          component: Totem,
          meta: {
            permissionId: 5,
            modalTitle: "Cadastrar novo totem",
            modalComponent: "FormTotem",
            action: {
              text: "Novo",
              event: "createTotem",
              icon: "plus"
            },
            icon: "fas fa-th-large",
            disabled: false,
            auth: true,
            id_permissao: 4,
            showCompanyMenu: true,
            pageTitle: "Totem"
          }
        }
      ]
    },
    // {
    //   path: "/user",
    //   name: "User",
    //   component: User,
    //   meta: {
    //     modalTitle: "Criar Agendamento",
    //     modalComponent: "AppModalNewAppointment",
    //     action: {
    //       text: "Novo",
    //       event: "createAppointment",
    //       icon: "plus"
    //     },
    //     icon: "far fa-calendar",
    //     auth: true
    //   },
    //   beforeEnter: (to, from, next) => {
    //     if (Store.state.user_data.master) {
    //       next({
    //         path: "/company"
    //       });
    //     } else {
    //       next();
    //     }
    //   }
    // },
    {
      path: "*",
      redirect: "/"
    }
  ]
});

router.beforeEach((to, from, next) => {
  if ((to.meta.auth === true) & (Store.state.authenticated === false)) {
    //verifica a autenticacao se nao tiver logado nao passa deste ponto
    next("/");

  }else {
     if(to.meta.name == "login" && (Store.state.authenticated === true)){
        next("/company");
     }else{
        //se não o master e passar por essas rotas redirecionar para company
        if((to.name == "Instituições" || to.name == "Dashboard") && Store.state.user_data.master === false){
           next("/company/context/home")
        }else{
           
           if(to.meta.ignoreCheck){
              if(Store.state.user_data.master && to.name == "Home"){
                next('/company/context/schedules')
              }
             next();
             return;
           }

           //caso não seja master verificar a permissão de cada tela
            if(Store.state.user_data.master) {
              next();
            }else{
                //verifica se tem acesso a tela
                 if(VerificarAcessoPermissao(to.meta.permissionId)||to.name == "Convites"){
                   next();
                 }else{
                   next("/company/context");
                 }

            }
        }
     }
  }
});

export default router;
